import { render, staticRenderFns } from "./product-bonus.vue?vue&type=template&id=3951771c&"
import script from "./product-bonus.vue?vue&type=script&lang=js&"
export * from "./product-bonus.vue?vue&type=script&lang=js&"
import style0 from "./product-bonus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3951771c')) {
      api.createRecord('3951771c', component.options)
    } else {
      api.reload('3951771c', component.options)
    }
    module.hot.accept("./product-bonus.vue?vue&type=template&id=3951771c&", function () {
      api.rerender('3951771c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-bonus.vue"
export default component.exports